export const tokenAddress = '0xCdCae0f44126773cDb2c2049aaDf35dE8c1d6d51';
export const stakingAddress = '0x8fB025313181e2c6d79F82845259695cE46027cb';

export const mainAdmin = '0x0589b06C1a61ECc64844187DAe64B8A7Aa463Ca5';
export const claimAdmin = '0x8fFfD79B4a56dCB9fa1416b2C75bAC3776176308';
export const admins = [
  '0xe8666427D06d7b0510A8d4a2dA76bCd55Cb64016',
  '0x0589b06C1a61ECc64844187DAe64B8A7Aa463Ca5',
];

/**
 * Проект Reown для WalletConnect. Не секрет — он всё равно уходит в бандл;
 * чужой домен Reown отвергнет по списку разрешённых в настройках проекта.
 */
export const WALLETCONNECT_PROJECT_ID = '1218db21f116882e7ad413e44833d6af';

export const STAKING_RATES = [
  { days: 90, rate: 5 },
  { days: 180, rate: 12 },
  { days: 360, rate: 30 },
  { days: 720, rate: 66 },
  { days: 1080, rate: 108 },
  { days: 1440, rate: 153 },
  { days: 1800, rate: 242 },
];

export const getRateByDays = (days) => {
  const found = STAKING_RATES.find((r) => r.days === days);
  return found ? found.rate : 0;
};

/**
 * Сумма к выплате по окончании срока: тело стейка плюс начисление по ставке.
 *
 * Ставка в сетке — суммарный процент за весь срок, а не годовой: иначе 5% за
 * 90 дней и 242% за 1800 не складываются в одну шкалу. Это расчёт панели по
 * сетке из конфига, а не значение контракта, — так он и подписан в окне
 * подтверждения. Расхождение сетки с контрактом ничем не проверяется.
 */
export const getStakePayout = (amount, days) =>
  (Number(amount) * (100 + getRateByDays(days))) / 100;

/**
 * Бессрочный стейкинг.
 *
 * Знаменатель ставки — 1000, тот же, что у срочных тарифов: `120` = 12%
 * годовых. В первой редакции задания были базисные пункты; в задеплоенном
 * контракте их нет. Панель везде показывает проценты, в контракт уходит сырое
 * значение.
 */
export const PERPETUAL_RATE_DENOMINATOR = 1000;

/** Год начисления в контракте: 365 дней, без учёта високосных. */
export const SECONDS_PER_YEAR = 365 * 24 * 60 * 60;

/** Проценты годовых → сырое значение контракта: 12 → 120. */
export const aprToRate = (apr) =>
  Math.round(Number(apr) * (PERPETUAL_RATE_DENOMINATOR / 100));

/** Сырое значение контракта → проценты годовых: 120 → 12. */
export const rateToApr = (rate) =>
  Number(rate) / (PERPETUAL_RATE_DENOMINATOR / 100);
